import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axiosInstance from "../../Services/AxiosAPICaller";
import { ILinks } from "../../Interfaces/ILinks";
import "./LinkGetter.css";

const LinkGetter: React.FC = () => {
  const { Id } = useParams<{ Id: string }>();
  const [Links, setLink] = useState<ILinks[]>([]);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    // Remplacez l'URL par l'endpoint réel de votre API
    axiosInstance
      .get<{ data: { id: number; attributes: any }[] }>(
        `/liens-utiles?populate[groupe_de_lien][fields][0]=Id&filters[groupe_de_lien][id]=${Id}`
      )
      .then((response) => {
        // check if returned data is an array
        if (Array.isArray(response.data.data)) {
          // log data for debug
          // console.log('Données reçues:', response.data.data);

          // Create Link Object From API returned Datas
          const Link = response.data.data.map((item) => ({
            Id: item.id,
            Uri: item.attributes.url,
            Displayed_Txt: item.attributes.texte_affiche,
            LinkGroup: item.attributes.groupe_de_lien,
          }));

          setLink(Link);
        } else {
          setError("La réponse de l'API n'est pas un tableau.");
          console.error("La réponse de l'API n'est pas un tableau.");
        }
      })
      .catch((error) => {
        console.error("Erreur lors de la récupération des objets :", error);
      });
  }, [Id]);

  return (
    <div className="LinkContainer">
      {error && <p>{error}</p>}

      {Links.length > 0 ? (
        Links.map((L) => (
          <a href={`${L.Uri}`} key={L.Id} className={`LinkBtn`}>
            {L.Displayed_Txt || L.Uri}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17.31"
              height="17.31"
              viewBox="0 0 17.31 17.31"
            >
              <path
                id="Tracé_23"
                data-name="Tracé 23"
                d="M0,0V17.31H17.31V10.818H15.144v4.326H2.163V2.163H6.492V0ZM10.818,0V2.163h2.706L7.572,8.115,9.195,9.738l5.952-5.952V6.492H17.31V0Z"
                fill="#fff"
              />
            </svg>
          </a>
        ))
      ) : (
        <p>Aucuns Liens à afficher.</p>
      )}
    </div>
  );
};

export default LinkGetter;
